import { Injectable } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private snackBar: MatSnackBar, private translateService: TranslateService) {}

  open(message: string, messageType = 'success') {
    const msg = this.translateService.instant(message);

    this.snackBar.open(msg, 'x', {
      duration: 3000,
      panelClass: messageType,
    });

    // message
  }
}

// let msg = '';
// this.translateService.get(message).subscribe((message) => {
//   msg = message;
// });

// const msg = this.translateService.get(message).subscribe((message) => message);

// import { MatSnackBar } from '@angular/material/snack-bar';
// constructor(private snackBar: MatSnackBar) {}

// , buttonText: string

// this.snackBar.open(message, 'x', {
//   duration: 3000,
//   panelClass: messageType,
// })

// EventEmitter
// import { MessageService } from 'primeng/api';
// import { Observable, Subject } from 'rxjs';

// nombre$ = new EventEmitter<any>();

//   constructor(private messageService: MessageService) {}

//   open(message: string, messageType = 'success') {
//     this.messageService.add({
//       severity: messageType,
//       summary: message,
//       detail: 'Order submitted',
//     });
//   }

//   private subject = new Subject<any>();

//   sendMessage() {
//     let abc = this.messageService.add({
//       severity: 'success',
//       summary: 'Success Message',
//       detail: 'Order submitted',
//     });

//     this.subject.next(abc);
//     // this.subject.next(this.open('cool'));
//     // this.subject.next({ text: 'message' });
//   }

//   getMessage(): Observable<any> {
//     return this.subject.asObservable();
//   }
